import {BaseContainerModel} from '../base-container.model';
import {app_mst_role_RowClass} from '../../dbschema/app_mst_role.model';

export class RoleContainerModel extends BaseContainerModel {
  app_mst_role: app_mst_role_RowClass = new app_mst_role_RowClass();
}
